import { render, staticRenderFns } from "./AppTextArea.vue?vue&type=template&id=91b255ea&scoped=true"
import script from "./AppTextArea.vue?vue&type=script&lang=js"
export * from "./AppTextArea.vue?vue&type=script&lang=js"
import style0 from "./AppTextArea.vue?vue&type=style&index=0&id=91b255ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b255ea",
  null
  
)

export default component.exports